module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback11-0fcfd452ebec67fc343def0339ab1e08.jpg";